module.exports = __webpack_public_path__ + "static/img/OKConfirmBtn.5c33c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OKConfirmBtn.png
// module id = 7JBn
// module chunks = 1